/** Parses a user-typed amount (Review screen manual edits) — simpler than the Gemini-output normalizer, since a human is typing a plain number, possibly with thousands commas. */
export function parseUserAmount(input: string): number | null {
  const trimmed = input.trim().replace(/,/g, '');
  if (trimmed === '') return null;
  const value = Number(trimmed);
  return Number.isFinite(value) ? value : null;
}
